import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../common/icons/AKKOPlan-Icon.svg'
import _imports_1 from '../common/icons/PhonePlan-Icon.svg'


_pushScopeId("data-v-3275c640")
const _hoisted_1 = { class: "form-container rounded p-4" }
const _hoisted_2 = { class: "d-flex align-items-center justify-content-between mb-4" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("h6", { class: "mb-0" }, "Select Your Plan", -1)
const _hoisted_4 = /*#__PURE__*/_createTextVNode(" Remove ")
const _hoisted_5 = { class: "d-flex gap-3" }
const _hoisted_6 = { class: "d-flex flex-column align-items-center justify-content-around" }
const _hoisted_7 = {
  key: 0,
  height: "70",
  width: "70",
  alt: "Phone Plan",
  src: _imports_0
}
const _hoisted_8 = {
  key: 1,
  height: "70",
  width: "70",
  alt: "Phone Plan",
  src: _imports_1
}
const _hoisted_9 = { class: "mb-0 mt-1 nowrap cera-med al-center-mobile" }
const _hoisted_10 = { class: "d-flex flex-column flex-grow-1 justify-content-center" }
const _hoisted_11 = { class: "d-flex flex-row mb-3" }
const _hoisted_12 = /*#__PURE__*/_createElementVNode("div", {
  class: "\n              d-flex\n              align-items-center\n              justify-content-center\n              select-label\n              fs-7\n              p-2\n            ",
  style: {"min-width":"56px"}
}, " Plan ", -1)
const _hoisted_13 = ["selected"]
const _hoisted_14 = ["selected", "value"]
_popScopeId()

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_CloseIcon = _resolveComponent("CloseIcon")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("button", {
        onClick: _cache[0] || (_cache[0] = (e) => _ctx.$emit('productRemoved')),
        class: "\n          px-25\n          py-1\n          btn btn-primary\n          inter\n          btn-mobile\n          w-100-mobile\n          fw-600\n          ml-auto\n          d-flex\n          align-items-center\n          fs-65\n        "
      }, [
        _createVNode(_component_CloseIcon, { class: "pointer close-icon" }),
        _hoisted_4
      ])
    ]),
    _createElementVNode("div", _hoisted_5, [
      _createElementVNode("div", _hoisted_6, [
        (!_ctx.icon)
          ? (_openBlock(), _createElementBlock("img", _hoisted_7))
          : _createCommentVNode("", true),
        (_ctx.icon && _ctx.icon == 'phone')
          ? (_openBlock(), _createElementBlock("img", _hoisted_8))
          : _createCommentVNode("", true),
        _createElementVNode("h6", _hoisted_9, _toDisplayString(_ctx.productGroupDisplayName), 1)
      ]),
      _createElementVNode("div", _hoisted_10, [
        _createElementVNode("div", _hoisted_11, [
          _hoisted_12,
          _createElementVNode("select", {
            class: "form-select p-2 fs-7 select",
            onChange: _cache[1] || (_cache[1] = (e) => _ctx.$emit('productSelected', e.target.value))
          }, [
            _createElementVNode("option", {
              value: "null",
              selected: _ctx.selectedProduct == null,
              disabled: ""
            }, " Select Plan ", 8, _hoisted_13),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.products, (product) => {
              return (_openBlock(), _createElementBlock("option", {
                key: product.id,
                selected: _ctx.selectedProduct?.name == product.name,
                value: product.id
              }, _toDisplayString(product.name), 9, _hoisted_14))
            }), 128))
          ], 32)
        ])
      ])
    ])
  ]))
}